import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { Job, JSONApiDataObject, Municipality, ReduxEntity } from 'Douleutaras/types';
import { RootState } from 'Douleutaras/redux/store';

const jobMunicipalityAdapter = createEntityAdapter<JSONApiDataObject<Municipality>>({
  selectId: item => item.id
});

export const jobMunicipalitySlice = createSlice({
  name: 'jobMunicipality',
  initialState: jobMunicipalityAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<JSONApiDataObject<Job>>),
  reducers: {
    jobMunicipalityAdded: (state, action) => {
      jobMunicipalityAdapter.setMany(state, action.payload);
    }
  }
});

export const jobMunicipalitySelectors = jobMunicipalityAdapter.getSelectors((state: RootState) => state.jobMunicipality);
